import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { selectApp } from '../app.selectors';

export const selectUI = createSelector(selectApp, get('ui.editEmployee'));

export const selectReady = createSelector(selectUI, get('ready'));
